export default __webpack_public_path__ + "static/summarizing-new-a5dd779ccdabb5ee7fc9b8400d4b9178.webp";